import {useCallback, useEffect, useRef, useState} from 'react';
import {useGuardarPreferencias} from '../api/sesion';
import {columnasValidas, type DefinicionDeColumnas} from './columnas';
import {useUsuario} from './sesion-contexto';

// Las columnas visibles de una tabla, leidas de las preferencias del usuario
// y guardadas en el servidor (con una pequena espera para no guardar en cada
// clic). Devuelve la lista y la funcion para cambiarla.
export function useColumnas<T, O extends string>(definicion: DefinicionDeColumnas<T, O>) {
  const usuario = useUsuario();
  const guardar = useGuardarPreferencias();
  const [columnas, setColumnas] = useState<string[]>(() =>
    columnasValidas(definicion, usuario.preferencias.columnas[definicion.clave]),
  );
  const pendiente = useRef<ReturnType<typeof setTimeout> | null>(null);
  const guardarRef = useRef(guardar);
  guardarRef.current = guardar;

  useEffect(
    () => () => {
      if (pendiente.current) clearTimeout(pendiente.current);
    },
    [],
  );

  const cambiar = useCallback(
    (ids: string[]) => {
      const validas = columnasValidas(definicion, ids);
      setColumnas(validas);
      if (pendiente.current) clearTimeout(pendiente.current);
      pendiente.current = setTimeout(() => {
        pendiente.current = null;
        guardarRef.current.mutate({columnas: {[definicion.clave]: validas}});
      }, 600);
    },
    [definicion],
  );

  return [columnas, cambiar] as const;
}
